import { fiftyfive, seventyfive, hundredbythirty, hundredbyfifty, eightyeight } from "../images-index";
import { useState } from 'react';


function Buttons (){
    //one-time grabbing the filtered list of images
    const fiftyfive_ch1 = Object.groupBy(fiftyfive, item => item.tag)["ch1"];
    const seventyfive_ch1 = Object.groupBy(seventyfive, item => item.tag)["ch1"];
    const hundredbythirty_ch1 = Object.groupBy(hundredbythirty, item => item.tag)["ch1"];
    const hundredbyfifty_ch1 = Object.groupBy(hundredbyfifty, item => item.tag)["ch1"];
    const eightyeight_ch1 = Object.groupBy(eightyeight, item => item.tag)["ch1"];

    //containers for final image list which updates in spoilersHandler
    const [fiftyfive_filtered, setFiftyFive] = useState(Object.groupBy(fiftyfive, item => item.tag)["ch1"]);
    const [seventyfive_filtered, setSevenyFive] = useState(Object.groupBy(seventyfive, item => item.tag)["ch1"]);
    const [hundredbythirty_filtered, setHundredByThirty] = useState(Object.groupBy(hundredbythirty, item => item.tag)["ch1"]);
    const [hundredbyfifty_filtered, setHundredByFifty] = useState(Object.groupBy(hundredbyfifty, item => item.tag)["ch1"]);
    const [eightyeight_filtered, setEightyEight] = useState(Object.groupBy(eightyeight, item => item.tag)["ch1"]);
    
    //styling the images
    let listFiftybyFifty = fiftyfive_filtered.map(temp =><img key = {temp.key} src={temp.link} alt="slay the princess icon"/> );
    let listSeventyFive = seventyfive_filtered.map(temp =><img  key = {temp.key} src={temp.link}  alt="slay the princess icon"/> );
    let listHundredbyThirty = hundredbythirty_filtered.map(temp =><img  key = {temp.key} src={temp.link}  alt="slay the princess icon"/> );
    let listHundredbyFifty = hundredbyfifty_filtered.map(temp =><img  key = {temp.key} src={temp.link}  alt="slay the princess icon"/> );
    let listEightyEight = eightyeight_filtered.map(temp =><img  key = {temp.key} src={temp.link}  alt="slay the princess icon"/> );
  
    
    //create array of images to display
    let list_container_FiftybyFifty = listFiftybyFifty;
    let list_container_SeventyFive = listSeventyFive;
    let list_container_HundredbyThirty = listHundredbyThirty;
    let list_container_HundredbyFifty = listHundredbyFifty;
    let list_container_EightyEight = listEightyEight;


    const spoilersHandler = (e) => {
        let checked = e.target.checked;
        if (checked){
            setFiftyFive(fiftyfive);
            setSevenyFive(seventyfive);
            setHundredByThirty(hundredbythirty);
            setHundredByFifty(hundredbyfifty);
            setEightyEight(eightyeight);
        }
        else {
            setFiftyFive(fiftyfive_ch1);
            setSevenyFive(seventyfive_ch1);
            setHundredByThirty(hundredbythirty_ch1);
            setHundredByFifty(hundredbyfifty_ch1);
            setEightyEight(eightyeight_ch1);
        }
    };


    return(
    <div className="fans-list-container">
        {/* HEADER */}
        <div className="header-bar  ">
            <div className="page-title">Codes</div>
                    <div className="spoiler-checkbox">
                        <label for="spoiler"> Spoilers?</label><br></br>
                        <input type="checkbox" id="spoiler" name="spoiler" value="spoiler" onChange={spoilersHandler}/>
                    </div>
        </div>
        <div className="info">
            <p>Feel free to add any of these buttons to your site!</p>
            <p>Buttons with content beyond Chapter 1 are hidden by default. Click the "Spoilers" checkbox to see them all.</p>
            <p>Want to create a button to add to this site? Email me :) Donations are welcome!</p>

            <p></p>
        </div>
        {/* LIST */}
        <div className="buttons-container">
            <h3>55 x 55</h3>
            <div className="buttons-display">
                {list_container_FiftybyFifty}
            </div>
            <h3>75 x 50</h3>
            <div className="buttons-display">
                {list_container_SeventyFive}
            </div>
            <h3>88 x 31</h3>
            <div className="buttons-display">
                {list_container_EightyEight}
            </div>
            <h3>100 x 35</h3>
            <div className="buttons-display">
                {list_container_HundredbyThirty}
            </div>
            <h3>100 x 50</h3>
            <div className="buttons-display">
                {list_container_HundredbyFifty}
            </div>
            {/* 
            <p>200x30</p>
            <p>Stamps</p> */}
        </div>
       
    </div>
    );
}

export default Buttons;